import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import './SurveyComplete.css';

const SurveyComplete = props => {
  props.setSubmitted(true);
  return (
    <div
      id="callInfoDiv"
      style={{
        display: 'flex',
        justiyContent: 'space-between',
        flexDirection: 'column',
      }}
    >
      <FontAwesomeIcon icon={faCircleCheck} className="circleCheck" />
      <p id="surveySubmitted" className="surveySubmittedText fs-unmask">
        Your call report has been submitted
      </p>
    </div>
  );
};

SurveyComplete.propTypes = {
  setSubmitted: PropTypes.func.isRequired,
};

export default SurveyComplete;
